var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"contact-card-singleton-container",class:{
    'high-contrast' : _vm.isHighContrastThemeActive,
    'mobile-container' : _vm.$vuetify.breakpoint.mobile
  },style:(_vm.POSITIONING),on:{"mouseenter":_vm.keepOpen,"mouseleave":_vm.close}},[_c('SmsContactCard',{ref:"contactCard",attrs:{"quick-message":"","contact":_vm.contact},on:{"message-sent":_vm.syncClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }